import { render, staticRenderFns } from "./EmployeeWizardGfOnly.vue?vue&type=template&id=87545196"
import script from "./EmployeeWizardGfOnly.vue?vue&type=script&lang=js"
export * from "./EmployeeWizardGfOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports